<script>
    import BackArrow from "../../../Components/Common/BackArrow.svelte";

    import PersonalDetailsFormPhase_1 from "./PersonalDetailsForm_Phase_1.svelte";
    import PersonalDetailsFormPhase_2 from "./PersonalDetailsForm_Phase_2.svelte";
    import PersonalDetailsFormPhase_3 from "./PersonalDetailsForm_Phase_3.svelte";

    export let updatePhase = () => {};
    export let personalDetails = {};

    let personalDetailsFormPhase = 1;
    // let personalDetailsFormPhase = 3;

    const updatePersonalDetailsPhase = (phase) => {
        if (phase <= 3) personalDetailsFormPhase = phase;
        else updatePhase(4);
    };
</script>

<div class="flex w-full gap-x-4 items-center justify-start">
    <BackArrow
        backFunc={() =>
            personalDetailsFormPhase == 1
                ? updatePhase(1)
                : updatePersonalDetailsPhase(personalDetailsFormPhase - 1)}
    />
    <p class="text-[32px] font-bold text-primary">
        {personalDetailsFormPhase != 2
            ? "Complete Your Profile"
            : "Phone validation"}
    </p>
</div>

{#if personalDetailsFormPhase == 1}
    <PersonalDetailsFormPhase_1
        {updatePersonalDetailsPhase}
        bind:personalDetails
    />
{:else if personalDetailsFormPhase == 2}
    <PersonalDetailsFormPhase_2
        {updatePersonalDetailsPhase}
        bind:personalDetails
    />
{:else if personalDetailsFormPhase == 3}
    <PersonalDetailsFormPhase_3
        {updatePersonalDetailsPhase}
        bind:personalDetails
    />
{/if}
